import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicFieldsManagerService {

  dynamicFields: any[] = [];

  constructor() { }

  setInitValues(model: any): any {
    console.log("DFMS model", model);
    console.log("DFMS props", this.dynamicFields);

    for (var i = 0; i < this.dynamicFields.length; i++) {
      if (typeof model[this.dynamicFields[i]] == "undefined" && model[this.dynamicFields[i]] == null) {
        model = this.assign(model, this.dynamicFields[i], {});
      }
    }

    return model;

  }

  assign(obj, path, val, shouldAssign = false): any {
    const keys = path.split('.');
    const lastKey = keys.pop();
    const lastObj = keys.reduce((obj, key) =>
      obj[key] = obj[key] || {},
      obj);

    if (!shouldAssign) {
      if (lastObj[lastKey] == null || typeof lastObj[lastKey] == "undefined") {
        lastObj[lastKey] = val;
      }
    }else{
      lastObj[lastKey] = val;
    }

    return obj;
  }

  getValue(o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    return o;
  }

  setProp(o, s, v){
    this.assign(o, s, v, true);
  }
  
  getProp(o, s) {
    return this.getValue(o,s);
  }
}
